import { Component, inject, signal } from '@angular/core';

import { IstatHeaderComponent } from './components/istat-header/istat-header.component';
import { IstatFilterComponent } from './components/istat-filter/istat-filter.component';
import { FEATURE_ISTAT_TRANSLATIONS } from './translations/feature-istat.translations';
import { RoutedComponent, RoutedComponentMeta } from '@h5s/util-routing';
import { IstatTableComponent } from './components/istat-table/istat-table.component';
import { FeatureIstatStore } from './store/feature-istat.store';
import { IstatFilterModel } from './components/istat-filter/models/istat-filter-model';

const COMPONENTS = [IstatHeaderComponent, IstatFilterComponent, IstatTableComponent];

/**
 * Eventi gestiti all'interno di IstatTableComponent
 */
@Component({
  selector: 'h5s-feature-istat',
  imports: [...COMPONENTS],
  providers: [FeatureIstatStore],
  templateUrl: './feature-istat.component.html',
  styleUrl: './feature-istat.component.scss',
})
export class FeatureIstatComponent extends RoutedComponent {
  private readonly featureIstatStore = inject(FeatureIstatStore);

  /** Traduzioni */
  public readonly translation = FEATURE_ISTAT_TRANSLATIONS;

  public readonly filters = signal<IstatFilterModel | null>(null);

  /** Definizione del Tab */
  override meta: RoutedComponentMeta = {
    icon: 'z_istat',
    title: this.translation.titleHeader,
  };

  constructor() {
    super();
    this.updateMeta(); // Aggiornamento tab del componente
    this.featureIstatStore.loadOwnerIstatProfile().subscribe();
  }
}
